import { MEDIA_FILE_STUB_TYPE } from "@/config";
import { MediaContentDataType } from "@/types";

const getFilesMediaType = (files: File[]) => {
  let lastType = null;

  if (files.length === 0) {
    return null;
  }

  for (let i = 0, len = files.length; i < len; i += 1) {
    const { type } = files[i];

    if (lastType !== null && type !== lastType) {
      return null;
    }

    lastType = type;
  }

  if (lastType === "video/mp4") {
    return "video";
  }

  if (lastType === "application/pdf") {
    return "document";
  }

  return null;
};

const getMockFileFromContent = (content?: MediaContentDataType) => {
  if (!content) {
    return [];
  }

  const fileName =
    content?.metadata?.fileName ??
    content?.blob_name?.split("/")?.at(-1) ??
    "unknown";
  const fileType = content?.metadata?.fileType ?? MEDIA_FILE_STUB_TYPE;
  const fileSize = content?.metadata?.fileSize ?? "0";
  // Create a blob with the specified size using a more efficient approach
  const chunkSize = 1024 * 1024; // 1MB chunks
  const size = parseInt(fileSize, 10);
  const chunks = Math.ceil(size / chunkSize);
  const blob = new Blob(
    Array(chunks).fill(new Uint8Array(chunkSize)).slice(0, size)
  );

  const result = [
    new File([blob], fileName, {
      type: fileType,
      lastModified: 0, // used as flag
    }),
  ];

  return result;
};

const getMockFileFromBlobData = (
  blobName: string,
  metadata?: Record<string, string>
): File[] => {
  try {
    const fileName =
      metadata?.fileName ?? blobName?.split("/")?.at(-1) ?? "unknown";
    const fileType = metadata?.fileType ?? MEDIA_FILE_STUB_TYPE;
    const fileSize = metadata?.fileSize ?? "0";
    const chunkSize = 1024 * 1024; // 1MB chunks
    const size = parseInt(fileSize, 10);
    const chunks = Math.ceil(size / chunkSize);
    const blob = new Blob(
      Array(chunks).fill(new Uint8Array(chunkSize)).slice(0, size)
    );

    const result = [
      new File([blob], fileName, {
        type: fileType,
        lastModified: 0, // used as flag
      }),
    ];

    return result;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export { getFilesMediaType, getMockFileFromContent, getMockFileFromBlobData };
